import React from "react";
import DevicesTable from "./DevicesTable";

const Archived = () => {
  return <DevicesTable status="archived" />;
};

export default Archived;
